
import { useContext } from "react";
import { MigrationContext } from "../contexts/migrationContext";

export const useMigration = () => {
  const context = useContext(MigrationContext);

  return context;
};
